import { render } from "./LogoutModal.vue?vue&type=template&id=6aeccc0e"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"

import "./LogoutModal.vue?vue&type=style&index=0&id=6aeccc0e&lang=css"

import exportComponent from "C:\\Assembla\\VIV0006\\root\\dev\\QuizWhiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__